module.exports = __webpack_public_path__ + "img/lishirenwu@3x.b2ec09f1.png";